import { useQuery } from '@apollo/client'

import { graphene } from 'graphql/tags'

const connectedRetailersQuery = graphene`#graphql
  query ConnectedRetailers {
    connectedAccounts {
      edges {
        node {
          ... on RetailerAccount {
            id
            displayName
          }
        }
      }
    }
  }
`

type ConnectedQueryResult = {
  connectedAccounts: {
    edges: { node: { id: string; displayName: string } }[]
  }
}

export const useConnectedRetailers = () => {
  const { data, loading, error } = useQuery<ConnectedQueryResult>(
    connectedRetailersQuery,
  )

  return { data, loading, error }
}
